import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1fc70bce")

_pushScopeId("data-v-1fc70bce")
const _hoisted_1 = { class: "circular-border" }
const _hoisted_2 = {
  key: 1,
  class: "container"
}
const _hoisted_3 = { class: "currentSessions" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h4", null, "Sessão atual", -1)
const _hoisted_5 = { class: "sessions-date" }
const _hoisted_6 = {
  key: 0,
  class: "active-sessions"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("h4", null, "Sessões ativas", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Encerrar todas")
const _hoisted_9 = { class: "sessions" }
const _hoisted_10 = { class: "sessions-date" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Encerrar Sessões ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_header_with_balance = _resolveComponent("header-with-balance")
  const _component_sessions_skeleton = _resolveComponent("sessions-skeleton")
  const _component_ion_card_content = _resolveComponent("ion-card-content")
  const _component_ion_card = _resolveComponent("ion-card")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")
  const _component_ion_footer = _resolveComponent("ion-footer")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_content, null, {
        default: _withId(() => [
          _createVNode(_component_header_with_balance, {
            class: "balance-header",
            title: "Sessões",
            "has-go-back": true
          }),
          _createVNode("div", _hoisted_1, [
            ($setup.loadingRef)
              ? (_openBlock(), _createBlock(_component_sessions_skeleton, { key: 0 }))
              : (_openBlock(), _createBlock("div", _hoisted_2, [
                  _createVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _createVNode(_component_ion_card, null, {
                      default: _withId(() => [
                        _createVNode(_component_ion_card_content, null, {
                          default: _withId(() => [
                            _createVNode("p", _hoisted_5, _toDisplayString($options.dateToString($setup.currentSessionsRef.date)), 1),
                            _createVNode("span", null, "Dispositivo: " + _toDisplayString($options.getDevice($setup.currentSessionsRef.info)), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  ($setup.activeSessionsRef.length > 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_6, [
                        _createVNode("header", null, [
                          _hoisted_7,
                          _createVNode(_component_ion_button, { onClick: $options.logoutAllSessions }, {
                            default: _withId(() => [
                              _hoisted_8
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.activeSessionsRef, (sessions) => {
                          return (_openBlock(), _createBlock(_component_ion_card, {
                            key: sessions.id
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_ion_card_content, null, {
                                default: _withId(() => [
                                  _createVNode(_component_ion_checkbox, {
                                    onClick: ($event: any) => ($options.addSession(sessions.id, $event))
                                  }, null, 8, ["onClick"]),
                                  _createVNode("div", _hoisted_9, [
                                    _createVNode("p", _hoisted_10, _toDisplayString($options.dateToString(sessions.date)), 1),
                                    _createVNode("span", null, "Dispositivo: " + _toDisplayString($options.getDevice(sessions.info)), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]))
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, null, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_button, {
                disabled: _ctx.sessionsToLogout.length == 0,
                shape: "round",
                expand: "full",
                onClick: $options.logoutSessions
              }, {
                default: _withId(() => [
                  _hoisted_11
                ]),
                _: 1
              }, 8, ["disabled", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})